import generateActionFactory from 'utils/generateAction'


const generateAction = generateActionFactory('assessor/registration/')

const [
  GET_INIT_DATA,
  GET_INIT_DATA_SUCCESS,
  GET_INIT_DATA_FAIL
] = generateAction('GET_INIT_DATA')


const initialState = {
  initData: {},
  loaded: false,
  loading: false
}

/* eslint complexity: "off" */
export default function registrations(state = initialState, action) {
  switch (action.type) {
    case GET_INIT_DATA:
      return {
        ...state,
        loading: true
      }
    case GET_INIT_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        initData: action.result || {}
      }
    case GET_INIT_DATA_FAIL:
      return {
          ...state,
          loading: false,
          loaded: false,
          error: action.error
      }
    default:
      return state
  }
}

export function getRegistrationInitData(data) {
  return {
    types: [GET_INIT_DATA, GET_INIT_DATA_SUCCESS, GET_INIT_DATA_FAIL],
    promise: client => client.post('api/registration/get-init-data?', { data })
  }
}
